import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppSelector } from '@perxis-auto/instock-sdk/lib/shared/lib';
import { selectors as installationSelector } from '@perxis-auto/instock-sdk/lib/shared/store/installation/index';
import { QueryParamsEnum } from '@perxis-auto/instock-sdk/lib/shared/types';

import { APP } from '@/shared/config/app';

export function useAppScroll() {
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const isPageReady = useAppSelector(installationSelector.selectSlice).page.ready;

  const scrollTo = searchParams.get(QueryParamsEnum.ScrollTo);

  useEffect(() => {
    sessionStorage.removeItem(`${APP.sdk}/scroll`);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (!isPageReady || !scrollTo) {
      return;
    }

    let timeoutId: NodeJS.Timeout;

    const observer = new MutationObserver(() => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const el = document.querySelector(scrollTo);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        setSearchParams(
          prev => {
            prev.delete(QueryParamsEnum.ScrollTo);
            return prev;
          },
          { replace: true },
        );

        observer.disconnect();
      }, 200);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
      clearTimeout(timeoutId);
    };
  }, [isPageReady, scrollTo]);
}
